import { memo, SVGAttributes } from 'react';

export const AddIcon = memo(({ ...rest }: SVGAttributes<SVGSVGElement>) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.625 7.5C1.625 4.25533 4.25533 1.625 7.5 1.625C10.7447 1.625 13.375 4.25533 13.375 7.5C13.375 10.7447 10.7447 13.375 7.5 13.375C4.25533 13.375 1.625 10.7447 1.625 7.5ZM7.5 0.625C3.70304 0.625 0.625 3.70304 0.625 7.5C0.625 11.297 3.70304 14.375 7.5 14.375C11.297 14.375 14.375 11.297 14.375 7.5C14.375 3.70304 11.297 0.625 7.5 0.625ZM7.99998 4.66667C7.99998 4.39052 7.77612 4.16667 7.49998 4.16667C7.22384 4.16667 6.99998 4.39052 6.99998 4.66667V7H4.66665C4.39051 7 4.16665 7.22386 4.16665 7.5C4.16665 7.77614 4.39051 8 4.66665 8H6.99998V10.3333C6.99998 10.6095 7.22384 10.8333 7.49998 10.8333C7.77612 10.8333 7.99998 10.6095 7.99998 10.3333V8H10.3333C10.6095 8 10.8333 7.77614 10.8333 7.5C10.8333 7.22386 10.6095 7 10.3333 7H7.99998V4.66667Z"
      fill="currentColor"
    ></path>
  </svg>
));

export default AddIcon;
